import { render, staticRenderFns } from "./SurveyGrid.vue?vue&type=template&id=2c1384ce&scoped=true"
import script from "./SurveyGrid.ts?vue&type=script&lang=ts&external"
export * from "./SurveyGrid.ts?vue&type=script&lang=ts&external"
import style0 from "./SurveyGrid.vue?vue&type=style&index=0&id=2c1384ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1384ce",
  null
  
)

export default component.exports